<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <IndexView/>

  <ViewContainer>
    <section class="p-6">
      <BackButton class="mb-5" to_url="/stock-opname" />
    <PageTitle title="Tambah Stok Opname"/>
    <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500 dark:text-dark-500">
      <InputRadio
        v-model="formType" id="form-type" name="form-type" label="Tipe Stok Opname"
        :options="[{ value: 'common', label: 'Stock Opname' }, { value: 'misc', label: 'Lain-lain' }]"
        :valid="validation.form_type.valid"
        :error-message="validation.form_type.message"
      />
      <div class="flex justify-center">
        <Button type="submit" label="Buat Draft" :loading="loading" @click="submitStockOpname" />
      </div>
    </div>
  </section>
</ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import InputRadio from '@/components/form/InputRadio.vue';
import { mapActions } from 'vuex';
import { Button, ConfirmDialog, Toast } from "primevue";
import ViewContainer from '@/components/ViewContainer.vue';

export default {
  name: "AddEditCustomer",
  props: ['id'],
  components: {
    IndexView, PageTitle, BackButton, InputRadio, Button, ConfirmDialog, Toast, ViewContainer
  },
  data() {
    return {
      formType: null,
      isEdit: false,
      validation: {
        form_type: {
          valid: true,
          message: ''
        },
      },
      loading: false,
    }
  },
  methods: {
    ...mapActions('stock_opnames', ['createStockOpname']),
    submitStockOpname() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin membuat draft stok opname?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postStockOpname();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan draft stok opname', life: 3000 });
        }
      });
    },
    async postStockOpname() {
      try {
        this.loading = true;
        const stockOpnameData = {
          form_type: this.formType,
          status: "pending",
        };

        const { data } = await this.createStockOpname(stockOpnameData);

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Stock Opname telah dibuat', life: 5000 });
        this.$router.push(`/stock-opname/edit/${data.id}`);
      }
      catch (error) {
        console.error('Failed to save stock opname:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  },
  async created() {
    
  }
}
</script>